import { Modal, Col, Row } from "antd";
import React from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";

import { ContentLoader, FormField, FormFieldType } from "@components";
import { AppConfigActions, selectNaceBlockerUpdating } from "@redux";
import { i18, trb, checkMaxLength } from "@utilities";

import "./EditNaceBlocker.less";

export const EditNaceBlocker = ({ onClose, blockerConfig }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(selectNaceBlockerUpdating);

  const onSubmit = async data => {
    try {
      await dispatch(AppConfigActions.updateNaceBlockersItem(data));
      onClose();
    } catch {}
  };

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={blockerConfig}
      render={({ handleSubmit }) => {
        return (
          <Modal
            visible
            width={800}
            onOk={handleSubmit}
            onCancel={onClose}
            cancelText={trb(i18.Buttons.Cancel)}
            okText={trb(i18.Buttons.Ok)}
            okButtonProps={{ loading: isLoading }}
            cancelButtonProps={{ disabled: isLoading }}
          >
            <form className="my-4 edit-nace-blocker-config-form" onSubmit={handleSubmit}>
              {isLoading && <ContentLoader />}
              {!isLoading && (
                <>
                  <Row gutter={[16, 0]}>
                    <Col xs={24}>
                      <FormField
                        name="title"
                        component={FormFieldType.textarea}
                        title={trb(i18.ApplicationsLabels.NaceBlockerTitleInput)}
                        size="large"
                        className="mb-4"
                        maxLength={1000}
                        validate={checkMaxLength(1000)}
                        componentOptions={{ className: "no-resize nace-blocker-title-textarea" }}
                      />
                    </Col>

                    <Col xs={24}>
                      <FormField
                        name="code"
                        component={FormFieldType.input}
                        title={trb(i18.ApplicationsLabels.NaceBlockersCodeInput)}
                        size="large"
                        maxLength={6}
                        validate={checkMaxLength(6)}
                        className="mb-4 nace-blocker-code-input"
                      />
                    </Col>

                    <Col xs={24}>
                      <FormField
                        name="isActual"
                        component={FormFieldType.checkbox}
                        label={trb(i18.ApplicationsLabels.isActualFilterInput)}
                        inline={true}
                        size="large"
                        className="mb-4"
                      />
                    </Col>
                  </Row>
                </>
              )}
            </form>
          </Modal>
        );
      }}
    />
  );
};
